<template>
  <div>
    <h2 class="pb-2"><slot></slot></h2>
    <v-layout>
      <v-expansion-panel expand>
        <v-expansion-panel-content v-for="(item,index) in panels" :key="index">
          <div slot="header"><v-icon :color="item.color" class="pr-4">{{ item.icon }}</v-icon>{{item.title}}</div>
          <v-card>
            <v-card-text class="grey lighten-3">{{item.text}}</v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>

  </div>
</template>

<script>
  export default {
    name: 'AccordionWidget',
    props: ['panels'],
    data () {
      return {}
    }
  }
</script>

<style>


</style>




// WEBPACK FOOTER //
// src/components/widgets/AccordionWidget.vue